var React = require('react');

function ComputerSpeaker (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M64 320h224V96H64zM592 32H368a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zM480 96a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm0 320a96 96 0 1 1 96-96 96 96 0 0 1-96 96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M288 416H128a32 32 0 0 0 0 64h176.41A79.24 79.24 0 0 1 288 432zM0 80v256a48 48 0 0 0 48 48h240v-64H64V96h224V80a79.24 79.24 0 0 1 16.41-48H48A48 48 0 0 0 0 80zm480 80a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm0 64a96 96 0 1 0 96 96 96 96 0 0 0-96-96zm0 144a48 48 0 1 1 48-48 48 48 0 0 1-48 48z","className":"fa-primary","key":2})]);
}

ComputerSpeaker.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = ComputerSpeaker;

ComputerSpeaker.default = ComputerSpeaker;
